const confirm = {
  group: {
    status: {
      enable: "确定启用该群组吗？",
      stop: "确定暂停该群组吗？"
    }
  },
  message: {
    group: {
      del: "共将删除{nummer}个群组，请确认！"
    },
    sync:"是否确定同步目标:{account}?",
    toClose:"是否确认关闭？",//
    changeToPrice:"确认修改成当前价格？",//确认修改成当前价格
  },
  title:{
    orderDetails:"订单详情",//订单详情
    price:"价格确认",//价格确认

  }
};
export default confirm;



// WEBPACK FOOTER //
// ./src/api/lang/modules/confirm/confirm_zh.js